<template>
  <div class="layout-container">
    <Nav/>
    <div class="main-container">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>


<script>
import Nav from './components/nav'
import Footer from './components/footer'

export default {
  components: {
    Nav,
    Footer
  },
  data() {
    return {}
  },


  mounted() {

  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.layout-container {

}
</style>
